import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DescriptionIcon from '@mui/icons-material/Description';
import Badge from '@mui/material/Badge';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import EditPacketDialog from '../Packet_Components/EditPacketDialog';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { notifySomething } from '../_Utils/AppDocuCommon';
import AssocVechicleDialog from '../_Utils/AssocVehicleDialog';

class ActionsFormatter extends React.Component {

  deletePackageService = async (itemId) => {
    if (!window.confirm('Delete this package?')) return;
    try {
      const res = await AppDocuServiceCall.deletePacket(itemId);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error deleting package', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the packages list after deletion !!!
    } catch (error) {
      console.error('Error deleting package:', error);
      notifySomething('Error deleting package', 'error');
    }
  };
  
  render() {
    const { row, onOpenAssocVehicleDialog, onOpenEditDialog } = this.props;
    return (
      <div style={{ display: 'flex', gap: 0, alignItems: 'center', minWidth: 90 }}>
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onOpenEditDialog && onOpenEditDialog(row)}>
            <EditIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => this.deletePackageService(row.id)}>
            <DeleteIcon style={{ color: 'darkred', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="View Vehicles">
          <span>
            <IconButton size="small" onClick={() => onOpenAssocVehicleDialog && onOpenAssocVehicleDialog(row)}>
              <Badge badgeContent={row.machine_count > 0 ? row.machine_count : null} color="primary">
                <DirectionsCarIcon style={{ color: row.machine_count > 0 ? 'black' : 'darkgray', fontSize: 20 }} />
              </Badge>
            </IconButton>
          </span>
        </Tooltip> 
      </div>
    );
  }
};

export default class ActionsTypeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assocVehicleDialogData: null,
      itemDataToEdit: null,
    };
  }

  handleCloseAssocVehicleDialog = async () => {
    await this.setState({ assocVehicleDialogData: null });
    await this.props.onItemsChange(); // Refresh the packages list after 
  }
  
  render() {
    const { for: forColumns, ...rest } = this.props;
    return (
      <>
        <DataTypeProvider
          formatterComponent={props => <ActionsFormatter 
              row={props.row} 
              onOpenAssocVehicleDialog={row => this.setState({ assocVehicleDialogData: row })} 
              onOpenEditDialog={row => this.setState({ itemDataToEdit: row })}              
              onItemsChange={this.props.onItemsChange}
            />}
          for={forColumns}
          {...rest} />

        <AssocVechicleDialog
          packetId={this.state.assocVehicleDialogData ? this.state.assocVehicleDialogData.id : null}
          onClose={() => this.handleCloseAssocVehicleDialog()} />

        <EditPacketDialog
          itemId={this.state.itemDataToEdit ? this.state.itemDataToEdit.id : null}
          onClose={() => this.setState({ itemDataToEdit: null })}
          onItemsChange={this.props.onItemsChange}
          packageCodes={this.props.packageCodes} />
      </>
    );
  }
}
